import {useState} from "react";
import {FiPlus} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {SLAReportLogoDrawer} from "@/pages/reports/logos/SLAReportLogoDrawer.tsx";

interface SLAReportsActionsProps {
  onCreate: () => void;
}

export const SLAReportsActions = ({onCreate}: SLAReportsActionsProps) => {
  const [showLogoUpload, setShowLogoUpload] = useState(false);
  return (
    <div className="d-flex align-items-center gap-3">
      {showLogoUpload && <SLAReportLogoDrawer show={showLogoUpload} hide={() => setShowLogoUpload(false)} />}

      <Button variant={"secondary"} size="large" onClick={() => setShowLogoUpload(true)}>
        Global Report Settings
      </Button>

      <Button size="large" onClick={onCreate}>
        <Icon icon={FiPlus} /> Create SLA Report
      </Button>
    </div>
  );
};
